import React from 'react';
import Tooltip from '../../../../../common/StyledToolTip';
import { AnchorPointMarker } from '../../../../../mapComponents/Markers';
import appConstants from '../../../../../../appConstants';

const getAnchorPointMarkerParams = ({
  theme,
  isActiveAnchorPoint,
  isDisabledAnchorPoint,
  markerColor,
  markerSize
}) => {
  const disabledMarkerColor = isDisabledAnchorPoint ? appConstants.Colors.disabledColor : null;
  let backgroundColor = null;
  if (markerColor) {
    backgroundColor = markerColor;
  } else if (disabledMarkerColor) {
    backgroundColor = disabledMarkerColor;
  } else if (isActiveAnchorPoint) {
    backgroundColor = theme.commonAppHeaderTabColor;
  }
  const dimension = isActiveAnchorPoint ? '35px' : markerSize;
  return {
    gradientPrimaryColor: theme.gradientPrimaryColor,
    gradientSecondaryColor: theme.gradientSecondaryColor,
    dimension,
    backgroundColor
  };
};

const getAnchorPointMarker = ({
  anchorPointData,
  theme,
  isActiveAnchorPoint,
  isDisabledAnchorPoint,
  markerColor = '',
  marker = AnchorPointMarker,
  markerSize = '23px',
  ...otherProps
}) => {
  const otherMarkerColors = getAnchorPointMarkerParams({
    theme,
    isActiveAnchorPoint,
    isDisabledAnchorPoint,
    markerColor,
    markerSize
  });
  const markerType = isDisabledAnchorPoint ? appConstants.MARKER_TYPE.NON_ACTIVE : appConstants.MARKER_TYPE.ACTIVE;
  const tooltip = [anchorPointData.anchorPointName];
  const MarkerComponent = marker;
  return (
    <Tooltip enterDelay={0} title={<div>{anchorPointData.anchorPointName || 'Anchor Point'}</div>}>
      <div
        data-markername={`AnchorPointMarker_${markerType}`}
        data-tooltip={JSON.stringify(tooltip)}>
        <MarkerComponent {...otherMarkerColors} {...otherProps} />
      </div>
    </Tooltip>
  );
};

export { getAnchorPointMarker };
